import {setupBuiltin} from "./RedbrickBuiltin";
import {_setApis, _removeApis} from "./ApiExtension";
import {_getPresetScript} from "./presetScripts";

class ScriptLauncher {
  constructor(context) {
    this.context = context;

    this.redbrickBuiltin = {
      THREE: undefined,
      TWEEN: undefined,
      THREEADDON: undefined,
      MathUtils: undefined,
      DateUtils: undefined,
      NavigationUtils: undefined,
      REDBRICK: undefined,
      GSTAR: undefined,
    };

    this.globalObjects = {
      WORLD: undefined,
      GUI: undefined,
      PLAYER: undefined,
      MAINCAMERA: undefined,
      GLOBAL: undefined,
    };

    this.eventFunctions = {
      Start: [],
      Update: [],
      OnJoin: [],
      OnLeave: [],
      OnKeyDown: [],
      OnKeyUp: [],
      OnPointerDown: [],
      OnPointerMove: [],
      OnPointerUp: [],
    };
  }

  static defaultScript = "function Start() {\n\t\n}\n\nfunction Update(dt) {\n\t\n}";
  static getPresetScript = _getPresetScript;

  init() {
    const modules = setupBuiltin(this.context);
    for (const key in this.redbrickBuiltin) {
      this.redbrickBuiltin[key] = modules[key];
    }

    this.globalObjects = {
      WORLD: this.context.scenePlay,
      GUI: this.context.sceneGUI,
      PLAYER: this.context.avatar?.model,
      MAINCAMERA: this.context.playCamera,
      GLOBAL: {},
    };

    this.context.scenePlay.traverse(object => {
      // [TEMP] title 세팅 부분을 한 군데로 모아야 함
      object.userData.playInfo = {isAlive: true};
      this.setApis(object);
    });
    this.context.sceneGUI.traverse(object => {
      object.title = object.userData.title || `${object.name}(${object.uuid.substring(0, 3)})`;
      object.userData.playInfo = {isAlive: true};
      this.setApis(object);
    });
    this.setApis(this.globalObjects.MAINCAMERA);
  }

  setApis = _setApis.bind(this);

  receiveReduxMessage() {} // [TODO]
  getPlayer() {} // [TODO]

  generateUserScript() {
    const builtinList = Object.keys(this.redbrickBuiltin).join(",");
    const globalList = Object.keys(this.globalObjects).join(",");
    const functionList = Object.keys(this.eventFunctions).join(",");

    this.context.scenePlay.traverse(object => {
      if (!object.userData.canScript) return;
      this.extractFunctions(object, builtinList, globalList, functionList);
    });
    this.context.sceneGUI.traverse(object => {
      if (!object.userData.canScript) return;
      this.extractFunctions(object, builtinList, globalList, functionList);
    });
  }

  extractFunctions(object, builtinList, globalList, functionList) {
    object.userData.objectScripts?.clientScripts.forEach(script => {
      const parameters = "__RedbrickBuiltin__," + "__GlobalObjects__," + functionList;
      const functionBody = `
        const {${builtinList}} = __RedbrickBuiltin__;
        const {${globalList}} = __GlobalObjects__;
        ${script.source}
        return {${functionList}};
      `;
      const scriptFunction = new Function(parameters, functionBody).bind(object);
      const extractedFunctions = scriptFunction(this.redbrickBuiltin, this.globalObjects);

      Object.entries(extractedFunctions).forEach(([event, func]) => {
        if (func === undefined) return;
        if (this.eventFunctions[event] === undefined) return;
        this.eventFunctions[event].push(func.bind(object));
      });
    });
  }

  runUserScript() {
    document.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("keyup", this.onKeyUp);
    document.addEventListener("pointerdown", this.onPointerDown);
    document.addEventListener("pointermove", this.onPointerMove);
    document.addEventListener("pointerup", this.onPointerUp);

    this.eventFunctions.Start.forEach(func => func());

    this.update = dt => this.eventFunctions.Update.forEach(func => func(dt));
  }

  update(dt) {}

  onJoin(clientId, avatar) {
    try {
      this.eventFunctions.OnJoin.forEach(func => func(clientId, avatar));
    } catch (error) {
      window.alert(`${error.name} occurred in the OnJoin function: ${error.message}`);
      console.error(`${error.name} occurred in the OnJoin function: ${error.message}`);
    }
  }

  onLeave(clientId) {
    try {
      this.eventFunctions.OnLeave.forEach(func => func(clientId));
    } catch (error) {
      window.alert(`${error.name} occurred in the OnLeave function: ${error.message}`);
      console.error(`${error.name} occurred in the OnLeave function: ${error.message}`);
    }
  }

  onKeyDown = (event => {
    try {
      this.eventFunctions.OnKeyDown.forEach(func => func(event));
    } catch (error) {
      window.alert(`${error.name} occurred in the OnKeyDown function: ${error.message}`);
      console.error(`${error.name} occurred in the OnKeyDown function: ${error.message}`);
    }
  }).bind(this);

  onKeyUp = (event => {
    try {
      this.eventFunctions.OnKeyUp.forEach(func => func(event));
    } catch (error) {
      window.alert(`${error.name} occurred in the OnKeyUp function: ${error.message}`);
      console.error(`${error.name} occurred in the OnKeyUp function: ${error.message}`);
    }
  }).bind(this);

  onPointerDown = (event => {
    try {
      this.eventFunctions.OnPointerDown.forEach(func => func(event));
    } catch (error) {
      window.alert(`${error.name} occurred in the OnPointerDown function: ${error.message}`);
      console.error(`${error.name} occurred in the OnPointerDown function: ${error.message}`);
    }
  }).bind(this);

  onPointerMove = (event => {
    try {
      this.eventFunctions.OnPointerMove.forEach(func => func(event));
    } catch (error) {
      window.alert(`${error.name} occurred in the OnPointerMove function: ${error.message}`);
      console.error(`${error.name} occurred in the OnPointerMove function: ${error.message}`);
    }
  }).bind(this);

  onPointerUp = (event => {
    try {
      this.eventFunctions.OnPointerUp.forEach(func => func(event));
    } catch (error) {
      window.alert(`${error.name} occurred in the OnPointerUp function: ${error.message}`);
      console.error(`${error.name} occurred in the OnPointerUp function: ${error.message}`);
    }
  }).bind(this);

  dispose() {
    document.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("keyup", this.onKeyUp);
    document.removeEventListener("pointerdown", this.onPointerDown);
    document.removeEventListener("pointermove", this.onPointerMove);
    document.removeEventListener("pointerup", this.onPointerUp);

    Object.keys(this.eventFunctions).forEach(event => (this.eventFunctions[event] = []));
    Object.keys(this.globalObjects).forEach(key => (this.globalObjects[key] = undefined));

    this.context.sceneGUI.traverse(object => _removeApis.bind(this)(object));
  }
}

export default ScriptLauncher;
